export default __webpack_public_path__ + "static/media/Image-3.dcb17891.png";